import { zodResolver } from '@hookform/resolvers/zod'
import { Link, createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { AuthShell } from '@/components/auth-shell'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { authApi } from '@/lib/auth-api'

export const Route = createFileRoute('/account/password/reset/')({
  component: PasswordResetRequestPage,
})

const requestSchema = z.object({
  email: z.email('Podaj prawidłowy adres e-mail'),
})

function PasswordResetRequestPage() {
  const [sent, setSent] = useState(false)
  const [requestError, setRequestError] = useState<string | null>(null)
  const form = useForm({
    resolver: zodResolver(requestSchema),
    defaultValues: { email: '' },
  })

  const submit = form.handleSubmit(async ({ email }) => {
    setRequestError(null)
    const response = await authApi.requestPassword(email)
    if (response.status === 429) {
      setRequestError('Zbyt wiele żądań. Spróbuj ponownie później.')
      return
    }
    // TR-121: ogólny komunikat niezależnie od istnienia konta.
    setSent(true)
  })

  return (
    <AuthShell>
      <Card>
        <CardHeader>
          <CardTitle>Reset hasła</CardTitle>
          <CardDescription>
            Podaj adres e-mail konta, a wyślemy link do ustawienia nowego hasła.
          </CardDescription>
        </CardHeader>
        <CardContent>
          {sent ? (
            <div className="flex flex-col gap-4 text-sm">
              <p>
                Jeśli konto istnieje, wysłaliśmy wiadomość z instrukcją resetu hasła. Sprawdź
                skrzynkę.
              </p>
              <Link
                to="/login"
                className="text-center text-muted-foreground underline-offset-4 hover:underline"
              >
                Wróć do logowania
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} className="flex flex-col gap-4" noValidate>
              <div className="flex flex-col gap-1.5">
                <Label htmlFor="email">E-mail</Label>
                <Input
                  id="email"
                  type="email"
                  autoComplete="email"
                  autoFocus
                  {...form.register('email')}
                />
                {form.formState.errors.email && (
                  <p className="text-sm text-destructive">{form.formState.errors.email.message}</p>
                )}
              </div>
              {requestError && <p className="text-sm text-destructive">{requestError}</p>}
              <Button type="submit" disabled={form.formState.isSubmitting}>
                Wyślij link resetu
              </Button>
              <Link
                to="/login"
                className="text-center text-sm text-muted-foreground underline-offset-4 hover:underline"
              >
                Wróć do logowania
              </Link>
            </form>
          )}
        </CardContent>
      </Card>
    </AuthShell>
  )
}
